// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ocXs","colMin":"styles_colMin__3uN0q"};